<template>
    <div style="position: relative;">
      <div class="dialog-title">
        <slot name="title"></slot>
      </div>
      <div class="dialog-content">
        <slot name="content"></slot>
      </div>
      <div class="mt-default">
        <slot name="btn"></slot>
      </div>
      <slot name="close">
      </slot>
    </div>
</template>
<script>
export default {
  name: 'base-dialog',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>

.dialog-title
  font-size: 22px;
  font-weight: bolder;
  letter-spacing: 1.2px;
  color: $primary-color
  margin-bottom: 20px;
.dialog-content
  color: $primary-color

.v-dialog
  .base-btn-primary
    margin: 20px 0px 0px!important;
  .base-btn-primary.flex
    display flex
    .v-btn
      flex: unset!important;
      width: unset
.v-dialog .base-btn-primary.flex .v-btn+.v-btn
    width: 140px!important;
    margin-left: 20px;
.v-dialog--active
  border-radius 10px!important

</style>
